import { useState } from 'react';

const faqs = [
  {
    question: '爱风月是一个什么样的品牌？',
    answer: '爱风月是一个专注于风雅生活美学的文化品牌，致力于传播风月文化内涵、分享诗意浪漫生活方式。我们通过文章、活动和体验，让更多人感受到东方美学的独特魅力。',
  },
  {
    question: '爱风月的内容多久更新一次？',
    answer: '我们每周发布2-3篇原创文章，涵盖风雅生活、月下风流、情趣雅致、古风美学、诗意浪漫和文化神韵六大主题。订阅我们的通讯，第一时间获取最新内容。',
  },
  {
    question: '如何参加爱风月的线下体验活动？',
    answer: '我们的线下体验活动（茶道、香道、古乐聆赏、书法雅集等）会定期在北京举办。活动信息会提前通过通讯邮件和公众号发布。您也可以关注我们的社交媒体获取最新活动资讯。',
  },
  {
    question: '可以在爱风月投稿吗？',
    answer: '当然可以！我们非常欢迎热爱风月文化的作者投稿。请将您的稿件发送至 hello@aifengyue.com，我们会在7个工作日内回复。稿件主题需与风月文化、生活美学相关。',
  },
  {
    question: '爱风月的文章是否免费阅读？',
    answer: '目前爱风月的所有线上文章均为免费阅读。我们相信风月之美应该属于每一个人，因此我们坚持开放分享。如果您喜欢我们的内容，订阅通讯是最好的支持方式。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <p className="text-primary-500 font-heading text-sm tracking-[0.2em] mb-3">常见问题</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            关于爱风月，你可能想了解
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-background-100/50 transition-colors cursor-pointer"
              >
                <h3 className="font-heading text-sm font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-foreground-500 text-sm leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}